import React, { useEffect, useState } from "react";
import styles from "./pages.module.css";
import { useParams } from "react-router-dom";

import { Footer } from "../comonents/Footer/Footer";

import { useMedia, useMediaUpdate } from "../contexts/MediaContext";
import { getMediaByID } from "../api/Api";
import { MediaBanner } from "../comonents/Banners/MediaBanner";
import { useUpdateNavigationContext } from "../contexts/NavagationContext";
import ErrorHandler from "../helpers/ErrorHandler";

export default function TVShow () {

    // ----------------------------------------------------- STATE AND HOOKS
    const tvshowID = useParams().tvshowID;
    let token = localStorage.getItem("token");

    const mediaUpdater = useMediaUpdate();
    const medaiItem = useMedia();

    const setCurrentLocation = useUpdateNavigationContext();
    setCurrentLocation("media");

    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => { 
        // checks to see if tvshow data has loaded yet
        if (Object.keys(medaiItem).length !== 0) {
            setIsLoaded(true);
        }
    }, [medaiItem]);

    useEffect(() => {
        // gets tvshow data once params come through
        mediaUpdater({}) // reset media to avoid flash of previous
        fetchTVShow();
    },[tvshowID])
    // ----------------------------------------------------- PRE-RENDER
    

    async function fetchTVShow() {
        await getMediaByID(tvshowID, token)
            .then((foundTVShow) => {
                mediaUpdater(foundTVShow);
            })
            .catch((error) => {
                console.log(error, "failed to fetch tv show");
                ErrorHandler(error);
            })
    }

    // ----------------------------------------------------- RENDER

    if (!isLoaded) {
        return (
            <></>
        )
    } else {
        return (
            <section className={styles.container}>
                <MediaBanner />
                <Footer />
            </section>
        )
    }
    
}